import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-collection-print',
  templateUrl: './collection-print.component.html',
  styleUrls: ['./collection-print.component.scss']
})
export class CollectionPrintComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
